import React, { useCallback, useEffect, useState } from "react";

import { useIntl } from "react-intl";

import { Tooltip } from "ds/Tooltip";
import { copyToClipboard } from "Libs/utils";

import * as S from "./ShareLink.styles";

type ShareLinkType = {
  link: string;
};

const ShareLink = (props: ShareLinkType) => {
  const { link = "", ...others } = props;
  const [copied, setCopied] = useState(false);
  const intl = useIntl();

  const onClick = useCallback(
    async (event: React.MouseEvent) => {
      event.preventDefault();
      await copyToClipboard(link);
      setCopied(true);
    },
    [link]
  );

  useEffect(() => {
    const timer = setTimeout(() => {
      if (copied) {
        setCopied(false);
      }
    }, 500);
    return () => clearTimeout(timer);
  }, [copied]);

  return (
    <S.Wrapper>
      <Tooltip
        tooltip={intl.formatMessage({
          id: copied
            ? "metrics.service.share.copied"
            : "metrics.service.share.copy"
        })}
        analyticId={
          copied ? "metrics.service.share.copied" : "metrics.service.share.copy"
        }
      >
        <S.ShareContainer onClick={onClick}>
          <S.IconCtr {...others}>
            {copied ? <S.Success /> : <S.Share />}
          </S.IconCtr>
          {intl.formatMessage({ id: "icons.share_link" })}
        </S.ShareContainer>
      </Tooltip>
    </S.Wrapper>
  );
};

export default React.memo(ShareLink);
